export const WATTS_IN_MW = 1_000_000
export const WATTS_IN_KW = 1000
